const doc = [({"en":({"adminConstantHotelFacilityType":({"activities":"Activities", "camping":"Camp", "hotel":"Hotel"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;